module.exports = __webpack_public_path__ + "img/roll-of-paper.f64ab7cc.png";